module.exports = __webpack_public_path__ + "static/media/original-book.b9609006.svg";